
<template>
  <div class="box">
    <div class="box-block">
      <div class="top-tips">
        <i class="icon icon-tips-light"></i>
        <span>{{getDict(31)}}</span>
      </div>
      <div class="talking" ref="chatBox">
        <div 
          class="word-block" 
          :class="{
            'my-text':!chat.anonymous && chat.uid == userData.uid,
            'admin-text':!chat.anonymous && chat.uid == 0
          }" 
          v-for="(chat,index) in chatList"
        >
          <div class="name-title">
            <span class="name">{{chat.anonymous ? getDict(36):(chat.uid == 0 ?getDict(75):chat.name)}}</span>
            <span class="point">:</span>
            <span class="ban-btn" @click="ban(chat)">
              <i class="icon icon-ban"></i>
            </span>
            
          </div>
          <div class="word">{{chat.content}}</div>
        </div>

        
      </div>
      <GetGoldBtn class="gold-box" :alertFunction="popTips"></GetGoldBtn>
      <!-- <div class="admin-tips" v-if="false">
       <div class="top">
         <span class="name">管理員信息</span>
         <span class="point">:</span>
         <span class="ban-btn">
           <i class="icon icon-close-range"></i>
         </span>
       </div>
        <div class="word">道路千萬條，安全第 一條。槍戰需謹慎,盒子~</div>
      </div> -->
      <div>
        <TalkInput @submit="sendChat"></TalkInput>
      </div>
      <div class="float-box" v-if="showFloatBox">
        <div class="ban-ctrl" v-if="popBanCtrl">
          <p class="title">{{getDict(32)}}</p>
          <div class="text">{{getDict(33)}}</div>
          <div class="ctrl">
            <div class="btn" @click="closeBan">{{getDict(22)}}</div>
            <div class="btn" @click="banDone">{{getDict(34)}}</div>
          </div>
        </div>
        <div class="ban-done" v-if="banTips.show">
          <div class="title">{{getDict(35) | formatDict(banTips.item.anonymous?'':banTips.item.name)}}</div>
          <!-- <div class="name">{{banTips.item.name}}</div> -->
        </div>
        <div class="pop-tips" v-if="popTipsDesc">
          <div class="name">{{popTipsDesc}}</div>
        </div>
      </div>
    </div>
    
  </div>
  
</template>

<script>

  import { bus, getDict, axios, webSocket } from '../common'
  import { invokeNative } from '../common'
  import { listen, unlisten } from '../common/invokeNative'
  import TalkInput from '../components/talkInput'
  import GetGoldBtn from '../components/getGoldBtn'
  import { mapState, mapGetters } from 'vuex'

  

  export default {
    props: {
      videoId:{}
    },
    data(){
      return {
        myID:'me',
        chatList:[
          // {
          //   name:'23453463tryrur',
          //   uid:'143245',
          //   content:'禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~'
          // },{
          //   name:'23453463tryrur',
          //   uid:'143245',
          //   content:'禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~'
          // },{
          //   name:'23453463tryrur',
          //   uid:'143245',
          //   content:'禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~'
          // },{
          //   name:'23453463tryrur',
          //   uid:'me',
          //   content:'禁止傳播違法低俗等不良信息~ &..彈幕內容彈幕內容~~'
          // },
        ],
        banList:[],
        banAnonymousList:[],
        chatListCache:[],
        popBanCtrl:false,
        banTips:{
          show:false,
          item:{},
        },
        videoChatObj:{
          videoTimmer:0,
          length:5 * 1000,
          next:0,
        },
        popTipsDesc:'',
        
      }
    },
    computed:{
      ...mapState(['userData','goingTime']),
      showFloatBox(){
        return this.popBanCtrl || this.banTips.show || this.popTipsDesc;
      },
    },
    watch:{
      'videoChatObj.videoTimmer'(){        
        if(this.videoChatObj.videoTimmer + 1.5 * 1000 > this.videoChatObj.next){
          this.getChat();
        }
      },
      chatList(){
        if(this.$refs.chatBox){
          this.$nextTick(()=>{
            this.$refs.chatBox.scrollTop = this.$refs.chatBox.scrollHeight
          })
          
        }
        
      },
      goingTime(){
        this.showChat()
      }
    },
    components: {
      TalkInput,GetGoldBtn
    },
    methods: {
      getDict,      
      ban(item){
        console.log(123)
        this.banTips.item = item;
        this.popBanCtrl = true;
      },
      closeBan(){
        this.banTips.item = {}
        this.popBanCtrl = false;
      },
      banDone(){
        this.banTips.show = true;
        this.popBanCtrl = false;

        if(this.banTips.item.anonymous){
          this.banAnonymousList.push(this.banTips.item.uid);
        }else{
          this.banList.push(this.banTips.item.uid);
        }
        
        setTimeout(()=>{
          this.banTips.show = false;
          this.closeBan();
        },3 * 1000)
      },
      popTips(str){
        this.popTipsDesc = str;
        setTimeout(()=>{
          this.popTipsDesc = '';
        },3 * 1000)
      },
      showChat(){
        let list = []
        for(let chat of this.chatListCache){
          if(chat.send_ts <= this.videoChatObj.videoTimmer){
            list.push(chat);
          }
        }
        
        this.chatListCache = this.chatListCache.filter((chat)=>{
          return !list.includes(chat)
        })
        list = list.filter((chat)=>{
          if(chat.uid == this.userData.uid){
            return true;
          }
          return !this.banList.includes(chat.uid) && !(this.banAnonymousList.includes(chat.uid) && chat.anonymous);
        })
        if(list.length){
          this.chatList = this.chatList.concat(list)
        }
        
      },
      addChat(chat){
        if(chat.send_ts < this.videoChatObj.videoTimmer - 5*1000){
          return;
        }
        if(chat.uid == this.userData.uid){
          return;
        }
        this.chatListCache.push(chat);
      },
      async getChat(){
        let data = await webSocket.get('/live/chat/find',{
          start_send_ts: this.videoChatObj.next,//按发送消息时间拉取聊天信息
          end_send_ts: this.videoChatObj.next + this.videoChatObj.length,//按发送消息时间拉取聊天信息
          room_id: this.videoId,//直播间id
          limit: 100, //一次限制拉取多少条
        });
        if(data.chat_infos){
          this.chatListCache = this.chatListCache.concat(data.chat_infos)
        }
        
        this.videoChatObj.next += this.videoChatObj.length;
      },
      async sendChat({text,anonymous}){
        await webSocket.get('/live/chat',{
          room_id: this.videoId,
          content:text,
          anonymous:anonymous||false,
          send_ts:this.videoChatObj.videoTimmer || 1,
        });
        this.chatList.push({
          uid: this.userData.uid,
          name: this.userData.userName,
          content: text,
          send_ts: this.videoChatObj.videoTimmer,
          anonymous:anonymous||false,
        })
      },
    },
    mounted(){
    },
    created(){
      // this.getChat();
      // console.log(123)
      this.$busOn('videoPlayTimeChange',(time)=>{

        this.videoChatObj.videoTimmer = time
        if(this.videoChatObj.videoTimmer > this.videoChatObj.next){
          this.videoChatObj.next = this.videoChatObj.videoTimmer;
        }
      });
      webSocket.listen('/live/chat/push',this.addChat)
    },
    beforeDestroy(){
      webSocket.offListen('/live/chat/push',this.addChat)
    }
  }
</script>

<style lang="scss" scoped>
  .box{
    height: 100%;
    width: 100%;
    background: rgba(40,40,40,1);
    padding: 0.1rem;
    .box-block{
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;

      .float-box{
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;

        .ban-ctrl{
          background: rgba(0,0,0,0.84);
          color: #fff;
          text-align: center;
          padding: 0.2rem;
          line-height: 0.3rem;
          width: 100%;
          .title{
            font-size: 0.24rem;
          }
          .text{
            font-size: 0.18rem;
          }
          .ctrl{
            display: flex;
            justify-content: space-between;
            margin-top: 0.1rem;


            .btn{
              background: url(../assets/button.png) no-repeat center center;
              background-size: 100% 100%;
              font-size: 0.18rem;
              height: 0.3rem;
              width: 40%;
              color: #000;
              
            }
          }
        }

        .ban-done{
          width: 100%;
          background: rgba(0,0,0,0.84);
          color: #fff;
          text-align: center;
          padding: 0.1rem;
          line-height: 0.3rem;
          font-size: 0.24rem;
        }
        .pop-tips{
          width: 100%;
          background: rgba(0,0,0,0.84);
          color: #fff;
          text-align: center;
          padding: 0.1rem;
          line-height: 0.3rem;
          font-size: 0.24rem;
        }
      }
      .top-tips{
        min-height: 0.4rem;
        padding-bottom: 0.1rem;
        border-bottom: 1px solid #595a5c;
        font-size: 0.15rem;
        color: #818181;
        padding-top: 0.05rem;
        .icon{
          margin-right: 0.05rem;
          vertical-align: middle;
        }
        span{
          // vertical-align: middle;
          // display: inline-block;
        }
      }
      .talking{
        $font-size: 0.17rem;
        font-size:$font-size;
        color: #fff; 
        line-height: $font-size * 1.3;
        flex: 1;
        overflow: scroll;

        
        :not(:last-child).word-block{
          border-bottom: 1px dotted #595a5c;
        }
        .word-block{
          padding: 0.1rem 0.05rem;

          &.my-text{
            color: #ffc44f;
            .name-title{
              color: #ffc44f; 
            } 

            .ban-btn{
              display: none !important;
            }
          }
          &.admin-text{
            color: #f04444;
            .name-title{
              color: #f04444;
            }

            .ban-btn{
              display: none !important;
            }
          }
          .name-title{
            display: flex;
            align-items: center;
            color: #a0a0a0;
            .name{
              overflow:hidden;
              text-overflow:ellipsis;
              white-space:nowrap
            }
            .point{
              flex: 1;
            }
            .ban-btn{
              display: flex;
              margin-left: 0.05rem;
              .icon-ban{
                width:$font-size *1.2;
                height:$font-size *1.2;
                margin: 0;
              }
            }
            
          }
        }

        
      }

      .admin-tips{
        $font-size: 0.17rem;
        .top{
          display: flex;
          align-items: center;
          .name{
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap
          }
          .point{
            flex: 1;
          }
          .ban-btn{
            display: flex;
            margin-left: 0.05rem;
            .icon-ban{
              width:$font-size;
              height:$font-size;
              margin: 0;
            }
          }
        }
       

        
        color: #acacac;
        background-color: #5f5f5f;
        padding:  0.05rem;
        padding-top: 0;
        margin-bottom: 0.1rem;
        font-size: $font-size;
        line-height: $font-size * 1.5;
      }
      .gold-box{
        position: absolute;
        bottom: 0.35rem;
        right: 0;
      }
    }

    
  }
</style>
